module.exports = __webpack_public_path__ + "static/media/report-disabled-dark.06920a1a.svg";